import { inter500 } from '@/config/fonts';
import {
  mergeAttributes,
  Node,
  NodeViewProps,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from '@tiptap/react';
import classNames from 'classnames';

import { labelColorVariants } from '@/shared/styles/labelColorVariants';

const AttributesComponent = (props: NodeViewProps) => {
  const variant = labelColorVariants['phaserbeam'];

  return (
    <NodeViewWrapper as="span" className="text-editor-attributes inline-block">
      <span
        className={classNames(
          'mx-1 rounded-md border px-2 py-0.5 text-nowrap',
          variant.bgColor,
          variant.textColor,
          variant.borderColor,
          {
            [`outline outline-2 ${variant.borderColor}`]: props.selected,
          },
          inter500.className
        )}
        data-key={props.HTMLAttributes.key}>
        {props.HTMLAttributes.text}
      </span>
    </NodeViewWrapper>
  );
};

const AttributesNode = Node.create({
  name: 'AttributesNodeComponent',
  group: 'inline',
  inline: true,
  atom: true,
  addAttributes() {
    return {
      text: { default: '' },
      key: { default: '' },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'text-editor-attribute',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['text-editor-attribute', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AttributesComponent);
  },
});

export default AttributesNode;
